import React from "react";
import "./Header.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { MdOutlineRestaurantMenu } from "react-icons/md";

const Header = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  return (
    <div>
      <nav className="app__navbar">
        <div className="app__navbar-logo">
          {/* <img src={images.gericht} alt="app__logo" /> */}
          <div>SeniorCare</div>
        </div>
        <ul className="app__navbar-links">
          <li className="p__opensans">
            <a href="/" id="p__opensans__home">
              Home
            </a>
          </li>
          <li className="p__opensans">
            <a href="#about">About</a>
          </li>
          <li className="p__opensans">
            <a href="#services">Services</a>
          </li>
          <li className="p__opensans">
            <a href="#resources">Resources</a>
          </li>
          <li className="p__opensans">
            <a href="#contact">Contact</a>
          </li>
        </ul>
        <div className="app__navbar-contact">
          <a href="#contact" className="p__opensans">
            Contact Us
          </a>
        </div>
        <div className="app__navbar-smallscreen">
          <GiHamburgerMenu
            color="#fff"
            fontSize={27}
            onClick={() => setToggleMenu(true)}
          />
          {toggleMenu && (
            <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
              <MdOutlineRestaurantMenu
                fontSize={27}
                className="overlay__close"
                onClick={() => setToggleMenu(false)}
              />
              <ul className="app__navbar-smallscreen_links">
                <li>
                  <a href="/" onClick={() => setToggleMenu(false)}>
                    Home
                  </a>
                </li>
                <li>
                  <a href="#about" onClick={() => setToggleMenu(false)}>
                    About
                  </a>
                </li>
                <li>
                  <a href="#services" onClick={() => setToggleMenu(false)}>
                    Services
                  </a>
                </li>
                <li>
                  <a href="#resources" onClick={() => setToggleMenu(false)}>
                    Resources
                  </a>
                </li>
                <li>
                  <a href="#contact" onClick={() => setToggleMenu(false)}>
                    Contact
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;
